import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './BlogSection.css';
import underlineImg from '../assets/underline.png';
import { IconLightning } from './Icons';

const BLOG_API = '/api/blog.php';

function formatDate(str) {
  if (!str) return '';
  return new Date(str).toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function BlogSection() {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetch(`${BLOG_API}?action=featured`)
      .then(r => r.json())
      .then(d => { if (d.success) setBlogs(d.rows || []); })
      .catch(() => {});
  }, []);

  if (blogs.length === 0) return null;

  return (
    <section className="blog-section" id="blog">
      <div className="blog-header">
        <div className="badge blog-badge">
          <span className="badge-icon"><IconLightning /></span>
          FROM THE BLOG
        </div>
        <h2 className="blog-title">
          Insights that drive
          <span className="blog-title-gradient"> real growth</span>
        </h2>
        <img src={underlineImg} alt="" className="blog-underline" />
        <p className="blog-subtitle">
          Actionable strategies, case studies, and e-commerce intelligence from our team.
        </p>
      </div>

      <div className="blog-grid">
        {blogs.map((post, i) => (
          <article
            key={post.slug}
            className={`blog-card${i === 0 ? ' blog-card--featured' : ''}`}
            onClick={() => navigate(`/blog/${post.slug}`)}
          >
            <div className="blog-card-img-wrap">
              <img src={post.cover_image} alt={post.title} className="blog-card-img" loading="lazy" />
              <span
                className="blog-card-cat"
                style={{ background: post.category_color || '#4f46e5' }}
              >
                {post.category}
              </span>
            </div>
            <div className="blog-card-body">
              <div className="blog-card-meta">
                <span className="blog-card-date">{formatDate(post.published_at)}</span>
                <span className="blog-card-dot" />
                <span className="blog-card-read">{post.read_time}</span>
              </div>
              <h3 className="blog-card-title">{post.title}</h3>
              <p className="blog-card-excerpt">{post.excerpt}</p>
              <span className="blog-card-link">
                Read article
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </span>
            </div>
          </article>
        ))}
      </div>

      <div className="blog-footer-row">
        <button className="blog-view-all" onClick={() => navigate('/blog')}>
          View All Articles
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </section>
  );
}
